const PROTOCOL_STEPS = [
  ["01", "A member refers you by name."],
  ["02", "We verify accreditation and sign documents once."],
  ["03", "Deals arrive with a memo that states what we do not know."],
  ["04", "You commit. We allocate in order, with stated exceptions."],
];

export default function Hero() {
  return (
    <section className="pt-24 pb-16 grid lg:grid-cols-[1.5fr_1fr] gap-16 items-end relative">
      <div className="ghost-enclosure hidden lg:block" aria-hidden="true"
        style={{ width: 380, height: 380, right: "-30px", top: "-40px" }} />
      <div className="ghost-enclosure hidden lg:block" aria-hidden="true"
        style={{ width: 190, height: 190, right: "300px", top: "180px", animationDelay: "-4s", opacity: 0.6 }} />
      <div>
        <span className="t-label rise" data-testid="hero-overline">A private membership for private markets</span>
        <h1 className="rise rise-1 mt-6 text-bone" data-testid="landing-lede"
          style={{ fontSize: "clamp(32px, 4.6vw, 54px)", lineHeight: 1.16, fontWeight: 400, letterSpacing: "-0.01em", maxWidth: "22ch" }}>
          Solera invests in mid and late stage private technology companies, and buys
          secondary positions in them.
        </h1>
        <p className="rise rise-2 mt-6 t-body text-muted-s measure">
          We close quickly and we say nothing. Membership is by referral, one member at a
          time. Every member is verified and every document is signed before a single deal
          is shown. There is no waitlist and there is no public list of anything.
        </p>
      </div>
      <div className="rise rise-3 gapped-enclosure p-6 sm:p-8" data-testid="hero-protocol-card">
        <span className="t-label">The protocol</span>
        <div className="mt-5 space-y-0">
          {PROTOCOL_STEPS.map(([n, t]) => (
            <div key={n} className="hairline py-4 flex gap-5 items-baseline first:border-t-0 first:pt-0">
              <span className="fig t-small text-tint">{n}</span>
              <span className="t-small text-bone">{t}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
